export default "__VITE_ASSET__e0d4ea76__"